import * as React from 'react';
import { Styleable, Style } from '../utils/styles';

const base: Style =
  'w-100 w-third-m2 ma1 aspect-ratio aspect-ratio--1x1 aspect-ratio--half-m aspect-ratio--third-l';
const inner: Style =
  'flex flex-column justify-between absolute bottom-0 left-0 right-0 top-0 items-center pa4';

export enum CardStyle {
  Default = 'bg-near-white black',
  Blank = 'bg-transparent',
  Gradient = 'bg-diagonal-gradient',
}

export interface CardProps extends Styleable {
  children: any;
  innerStyle?: Style;
}

export interface CardElement extends JSX.Element {
  props: CardProps;
}

export const Card = (props: CardProps) => (
  <div className={`${base} ${props.className}`}>
    <div className={props.innerStyle || inner}>{props.children}</div>
  </div>
);
